import { apiService } from '../api/api-client';
import { AvailabilityReportListItem, AvailabilityReportDetail } from '@/types';
import { PaginatedResponse } from '@/types/common.types';

export interface AvailabilityReportListParams {
  counterparty?: string;
  limit?: number;
  offset?: number;
}

export interface UpdateAvailabilityItemPayload {
  id: number;
  quantity: number;
  is_deleted?: boolean;
  counterparty_product_id?: string;
}

export interface CreateAvailabilityItemPayload {
  counterparty_product_id: string;
  symbol_id?: string;
  quantity: number;
}

export const availabilityReportService = {
  async getAvailabilityReports(params?: AvailabilityReportListParams): Promise<PaginatedResponse<AvailabilityReportListItem>> {
    return apiService.get<PaginatedResponse<AvailabilityReportListItem>>('/reports/availability/', { params });
  },

  async getAvailabilityReportDetail(id: number): Promise<AvailabilityReportDetail> {
    return apiService.get<AvailabilityReportDetail>(`/reports/availability/${id}/`);
  },

  async downloadReport(id: number): Promise<Blob> {
    return apiService.get<Blob>(`/reports/availability/${id}/download/`, {
      responseType: 'blob',
    });
  },

  async updateItems(reportId: number, updates: UpdateAvailabilityItemPayload[], create: CreateAvailabilityItemPayload[] = []): Promise<AvailabilityReportDetail> {
    return apiService.patch<AvailabilityReportDetail>(
      `/reports/availability/${reportId}/items/`,
      { updates, create }
    );
  },

  async resetReport(reportId: number): Promise<AvailabilityReportDetail> {
    return apiService.post<AvailabilityReportDetail>(
      `/reports/availability/${reportId}/reset/`
    );
  },

  async sendReport(reportId: number): Promise<AvailabilityReportListItem> {
    return apiService.post<AvailabilityReportListItem>(
      `/reports/availability/${reportId}/send/`
    );
  },
};
